export const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: 35
    },
    contract_contained: {
        fontSize: '10px',
        color: '#f4bc2b',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    },
    icon: {
        fontSize: '0.9em',
        marginRight: 3,
        color: '#f4bc2b'
    },
    mainTitle: {
        fontSize: '0.93em',
        color: '#000',
        fontWeight: '500',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap'
        //lineHeight: '10px'
    },

    selectOptoption: {
        borderBottom: '0.3px solid #d9d9d9',
        position: 'relative',

    },
    loadmore: {
        color: '#3a7be2',
        position: 'absolute',
        bottom: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '0px 10px',
        zIndex: 9999,
        marginBottom: '5px'
    },
    loadmoreOption: {
        padding: '0px 4px',
        backgroundColor: '#fff',
        cursor: 'pointer'
    },
    loadmoreLoading: {
        display: 'flex',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '0px 10px',
        marginBottom: '5px',
        zIndex: 9999,
    }
}
